import { hexToRGB } from '@repo-level/core-front';
import styled from 'styled-components/macro';

import { device } from 'components/styles/MediaQuery';

export const ScBirthday = styled.div`
  position: relative;

  & > .content {
    position: relative;
    padding: 32px 24px;
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    z-index: 2;

    &.de {
      padding: 32px 16px;
    }

    & > .action-btn {
      width: 100%;
      display: flex;
      justify-content: center;

      button {
        max-width: 232px;
      }

      &.de {
        button {
          font-size: 90%;
        }
      }
    }

    & > header {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > .sub-title {
        font-weight: 800;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
      }

      & > .title {
        font-weight: 800;
        font-size: 28px;
        line-height: 1.29;
        text-align: center;
        letter-spacing: 0.01em;
        color: ${({ theme }) => theme.whiteColor};
      }
    }

    & > .bday-description {
      font-weight: 400;
      font-size: 14px;
      line-height: 1.43;
      text-align: center;
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    }

    .benefits {
      position: relative;
      width: 100%;
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 8px;
      text-align: center;

      li {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: linear-gradient(
          90deg,
          rgba(230, 202, 100, 0) 0%,
          rgba(230, 202, 100, 0.4) 50.52%,
          rgba(230, 202, 100, 0) 100%
        );
        min-height: 54px;
        padding: 8px;
        border-radius: 12px;
        font-size: 14px;
        line-height: 20px;
        font-weight: 700;

        & > .title {
          text-align: center;
          color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.4)};
        }

        & > .description {
          color: ${({ theme }) => theme.whiteColor};
        }
      }
    }
  }

  .character {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 280px;
    object-fit: contain;
    z-index: 2;
  }

  @media (${device.mobileS}) {
    & > .content {
      padding: 0;
      &.de {
        padding: 0;
      }
      max-width: 100%;

      & > header {
        padding: 0 12px;
      }

      & > .bday-description {
        padding: 0 12px;
      }

      .benefits {
        text-align: left;

        li {
          align-items: flex-start;
          justify-content: center;
          padding: 8px 184px 8px 24px;
          background: linear-gradient(
            90deg,
            rgba(230, 202, 100, 0) 0%,
            rgba(230, 202, 100, 0.4) 50.52%,
            rgba(230, 202, 100, 0) 100%
          );

          &.de {
            padding: 8px 24px;
          }

          & > .title {
            text-align: left;
          }
        }
      }

      & > .action-btn {
        padding: 0 12px 32px;
        button {
          max-width: 100%;
        }
      }
    }

    .character {
      width: auto;
      height: 226px;
    }
  }
`;

export const ScSkipBonusField = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  .field-container {
    .label {
      font-size: 12px;
      line-height: 18px;
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    }
  }

  @media (${device.mobileS}) {
    margin: 48px 0 12px;
    padding: 0 12px;
  }
`;

export const ScOffer = styled.div`
  font-weight: 800;
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  letter-spacing: 0.03em;
  color: ${({ theme }) => theme.whiteColor};
`;
